export type BarChartData = BarChartDataValue[];

export type BarChartDataValue = number | IBarChartDataComplexValue;

export interface IBarChartDataComplexValue {
    value: number;
    tooltipName?: string;
    [key: string]: any;
}


export const isBarChartDataComplexValue = (value: BarChartDataValue): value is IBarChartDataComplexValue => {
    return (<IBarChartDataComplexValue>value).value !== undefined;
};
